module.exports = __webpack_public_path__ + "img/FGr_Wassergefahren_A.c0a04d21.svg";